exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pmresponse{\r\n color:#a89d06\r\n}\r\n\r\n.paresponse{\r\n color:#3172ea\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/components/project-wizard/project-wizard.component.css
// module id = ../../../../../src/app/components/project-wizard/project-wizard.component.css
// module chunks = main